<template>
  <div
    :class="['book-landing thankyou-page', { 'mobile': $q.platform.is.mobile }]"
    :style="styles"
  >
    <div
      v-if="headerTrackingCode"
      v-html="headerTrackingCode"
    />
    <HeaderComponent v-if="pageData.headerEnable" />
    <HeadlinesComponent v-if="pageData.headlinesEnable" />
    <MediaComponent v-if="pageData.mediaEnable" />
    <HeadlinesWithButtonComponent v-if="pageData.headlinesWithButtonEnable" />
    <CallToActionComponent v-if="pageData.callToActionEnable" />
    <FooterComponent v-if="pageData.footerEnable" />
    <div
      v-if="footerTrackingCode"
      v-html="footerTrackingCode"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useQuasar } from 'quasar';

import { useBookPageStore } from 'stores/bookPage';
import HeaderComponent from 'components/book-landing/render/HeaderComponent.vue';
import FooterComponent from 'components/book-landing/render/FooterComponent.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import MediaComponent from 'components/book-landing/render/MediaComponent.vue';
import HeadlinesWithButtonComponent from 'components/book-landing/render/HeadlinesWithButtonComponent.vue';
import HeadlinesComponent from 'components/book-landing/render/HeadlinesComponent.vue';
import CallToActionComponent from 'components/book-landing/render/CallToActionComponent.vue';

const $q = useQuasar();
const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

const { styles, headerTrackingCode, footerTrackingCode } = useBookPageEdit();
</script>
